import { Pressable, SxProp, View } from 'dripsy';
import React, { useMemo } from 'react';
import { INPUT_SIZE, INPUT_STATE, INPUT_VARIANT } from './types';

export interface InputBorderProps {
  variant: INPUT_VARIANT;
  state: INPUT_STATE;
  size?: INPUT_SIZE;
  sx?: SxProp;
  onPress?: () => void;
}

const INPUT_BORDER_COLOUR: Record<INPUT_STATE, string> = {
  default: '$borderInputDefault',
  focused: '$borderInputFocused',
  error: '$borderInputError',
  disabled: '$borderInputDisabled'
};

const INPUT_BORDER_RADIUS: Record<INPUT_VARIANT, number> = {
  squared: 0,
  rounded: 5,
  underlined: 0
};

export const InputBorder: React.FC<InputBorderProps> = ({ variant, state, size = INPUT_SIZE.MEDIUM, children, sx, onPress }) => {
  const borderColor = INPUT_BORDER_COLOUR[state];
  const borderRadius = INPUT_BORDER_RADIUS[variant];
  const borderWidth = variant === INPUT_VARIANT.UNDERLINED || state === INPUT_STATE.DISABLED ? 0 : 1;
  const borderBottomWidth = state === INPUT_STATE.DISABLED ? 0 : 1;
  const backgroundColor = state === INPUT_STATE.DISABLED ? '$backgroundInputDisabled' : 'transparent';

  const style: SxProp = useMemo(
    () => ({
      // BASE
      width: '100%',
      paddingX: '$4',
      flexDirection: 'row',
      alignItems: 'center',
      justifyConent: 'space-between',

      height: styles[size].height,

      borderRadius,
      borderColor,
      borderLeftWidth: borderWidth,
      borderRightWidth: borderWidth,
      borderTopWidth: borderWidth,
      borderBottomWidth,
      backgroundColor
    }),
    [state]
  );

  return (
    <Pressable sx={style} onPress={onPress}>
      {children}
    </Pressable>
  );
};

const styles: Record<INPUT_SIZE, SxProp> = {
  extraSmall: {
    height: '$8'
  },
  small: {
    height: '$9'
  },
  medium: {
    height: '$12'
  },
  large: {
    height: '$15'
  }
};
